export const packageInfo = [
    {
        id: 1,
        packageTitle: 'Premium',
        price: 105_000,
        list: [
            'Տևողությունը 1 ամիս',
            'Շաբաթական 2-3 դաս, որոնք կտեղադրվեն google disk-ում',
            'Յուրաքանչյուր շաբաթ հարց-պատասխան ֆորմատով հանդիպում zoom-ով',
            'Պրակտիկա',
            'Սերտիֆիկատ, որը կփաստի ձեր վաճառքի մասնագետ լինելը',
            '3 ամիս հետադարձ կապ',
            'Բոնուս դաս, որտեղ կուսուցանվի աշխատաշուկա մտնելու առաջին ճիշտ քայերը և ձեր անձնային բրենդը ստեղծելու ճիշտ քայլերը։'
        ]
    },
    {
        id: 2,
        packageTitle: 'Pro',
        price: 130_000,
        list: [
            'Տևողությունը 1 ամիս',
            'Շաբաթական 2-3 դաս, որոնք կկայանան zoom-ով',
            'Պրակտիկա',
            'Սերտիֆիկատ, որը կփաստի ձեր վաճառքի մասնագետ լինելը',
            '3 ամիս հետադարձ կապ',
            'Բոնուս դաս, որտեղ կուսուցանվի աշխատաշուկա մտնելու առաջին ճիշտ քայերը և ձեր անձնային բրենդը ստեղծելու ճիշտ քայլերը։',
            'Աշխատանքի տեղավորման աջակցություն պրակտիկայի շրջանակներում գերազանց ստացած ուսանողներին(3-6 ամսվա ընթացքում)'
        ]
    },
    {
        id: 4,
        packageTitle: 'VIP',
        subTitle: '(Անհատական)',
        price: 300_000,
        list: [
            'Տևողությունը 1 ամիս',
            'Շաբաթական 2-3 դաս, որոնք կանցկացվեն zoom ֆորմատով և ժամերը կհարմարեցվեն ձեզ հետ',
            'Պրակտիկա',
            'Սերտիֆիկատ, որը կփաստի ձեր մասնագետ լինելը',
            '1 ամիս ձեզ հետ զուգահեռ աշխատանք՝ անհրաժեշտության դեպքում',
            '6 ամիս հետադարձ կապ'
        ]
    },
]

export const sideBarInfo =
    [
        {name: 'Գլխավոր էջ', link: '/'},
        {name: 'Իմ մասին', link: '/about'},
        {name: 'Վաճառքներ', link: '/sales'},
        {name: 'Կարծիքներ', link: '/opinion'},
        // {name: 'Հաճախ տրվող հարցեր', link: '/faq'}
    ]
